"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
// ! 웹뷰앱 업데이트 안내
// ! 웹뷰앱 토큰 관리
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
function default_1({ confirm }) {
    const { isNativeApp, nativeAppVersion } = window;
    const sendingToken = (0, react_1.useRef)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, react_1.useLayoutEffect)(() => {
        if (isNativeApp) {
            if (nativeAppVersion && nativeAppVersion < Number(process.env.MIN_WVA_VER)) {
                confirm({
                    description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('꼭 필요한 업데이트라서 찾아왔어요!'), (0, jsx_runtime_1.jsx)("br", {}), t('업데이트하고 만나요~')] })),
                    confirmationText: t('업데이트'),
                    cancellationButtonProps: { style: { display: 'none' } },
                    allowClose: false,
                })
                    .then(() => window.open(string_utils_1.storeUrl))
                    .catch(() => { });
            }
            else {
                const postFCMTokenFromWVA = (message) => {
                    const { data } = message;
                    if (String(data).startsWith('FCMTOKEN') && !sendingToken.current) {
                        const hasCSRFToken = Boolean((0, functions_1.getCookie)('csrftoken'));
                        if (hasCSRFToken) {
                            sendingToken.current = true;
                            const token = data.split('::')[1];
                            (0, api_1.postData)('/api/v1/notification/token', { token })
                                .then(() => (0, webview_app_1.postMessageToWVA)('TOKENSENT'))
                                .catch(() => (0, webview_app_1.postMessageToWVA)('SENDTOKENFAILED'))
                                .finally(() => (sendingToken.current = false));
                        }
                        else
                            (0, webview_app_1.postMessageToWVA)('SENDTOKENFAILED');
                    }
                };
                window.addEventListener('message', postFCMTokenFromWVA);
                return () => {
                    window.removeEventListener('message', postFCMTokenFromWVA);
                };
            }
        }
    }, []);
}
exports.default = default_1;
